import React from 'react';
import useLang from '../hooks/useLang';
// import Header from './Header'; // Entfernt um doppelten Header zu vermeiden

const AboutUsPage = ({ onBack }) => {
  const { lang } = useLang();
  
  const content = {
    de: {
      title: "Über Uns",
      subtitle: "Unsere Wurzeln, Ihre Zukunft: Die Geschichte hinter Centeo",
      missionTitle: "Unsere Mission: Klarheit im Förderdschungel",
      missionText1: "Die Agrarförderung in der EU ist ein Labyrinth aus Anträgen, sich ändernden Vorschriften und unzähligen Programmen. Wir haben Centeo gegründet, weil wir glauben, dass jeder Landwirt – unabhängig von der Betriebsgröße oder dem technischen Know-how – einen fairen und einfachen Zugang zu der Unterstützung verdient, die ihm zusteht.",
      missionText2: "Unsere Mission ist es, durch intelligente Technologie die Komplexität der Förderlandschaft zu durchbrechen und die Zukunft der europäischen Landwirtschaft zu stärken, indem wir jedem Betrieb die bestmöglichen finanziellen Chancen aufzeigen.",
      originTitle: "Unsere Herkunft: Landwirtschaft im Herzen, Daten im Kopf",
      originText1: "Hinter Centeo steht die Lazzaro One UG, aber vor allem eine persönliche Geschichte. Unser Gründer, Arsenio Longo, entstammt einer Familie, in der seit Generationen Landwirtschaft betrieben wird. Er kennt aus eigener Erfahrung die harte Arbeit, die Leidenschaft und auch die wirtschaftlichen Herausforderungen, die das Leben als Landwirt mit sich bringt.",
      originText2: "Diese tiefe Verwurzelung in der Landwirtschaft verbindet er mit seiner doppelten Expertise aus Mathematik und Finanzwirtschaft.",
      originText3: "Diese einzigartige Kombination ermöglicht es uns, die komplexe Welt der Förderprogramme nicht nur analytisch zu verstehen, sondern auch immer aus der Perspektive eines Landwirts zu betrachten: Was bringt wirklich einen Mehrwert für den Betrieb und sichert dessen Zukunft? Centeo ist unsere Antwort auf diese Frage.",
      methodTitle: "Unsere Methode: Mehr als nur eine Datenbank",
      methodIntro: "Centeo ist mehr als eine einfache Suchmaschine. Unser System nutzt einen mehrstufigen, KI-gestützten Prozess, um für Sie die relevantesten Ergebnisse zu finden:",
      method1Title: "1. Umfassende Datensammlung:",
      method1Text: "Wir sammeln und pflegen kontinuierlich eine Datenbank mit hunderten Programmen – von den bekannten GAP-Zahlungen bis hin zu privaten Stiftungen, Steuererleichterungen und Nischen-Förderungen, die oft übersehen werden (\"Hidden Gems\").",
      method2Title: "2. Intelligentes Matching & Scoring:",
      method2Text: "Unser Algorithmus analysiert Ihre Betriebsdaten und bewertet jedes gefundene Programm individuell, um die Ergebnisse nach der höchsten Erfolgswahrscheinlichkeit und Passgenauigkeit für Ihre spezifische Situation zu sortieren.",
      method3Title: "3. Strategische Analyse:",
      method3Text: "Wir identifizieren zusätzlich, welche Förderungen miteinander kombinierbar sind, um Ihnen dabei zu helfen, Ihr Förderpotenzial zu maximieren und strategische \"Förder-Pakete\" zu schnüren.",
      promiseTitle: "Unser Versprechen an Sie",
      promiseIntro: "Ihr Vertrauen ist unser höchstes Gut. Deshalb verpflichten wir uns zu folgenden Grundsätzen:",
      promise1Title: "Datenschutz nach DSGVO:",
      promise1Text: "Ihre Betriebsdaten werden streng vertraulich behandelt, nur für die einmalige Analyse verwendet und niemals ohne Ihre Zustimmung an Dritte weitergegeben.",
      promise2Title: "Transparente Kosten:",
      promise2Text: "Ein einmaliger Preis für eine vollständige Analyse. Keine Abonnements, keine versteckten Gebühren.",
      promise3Title: "Geld-zurück-Garantie:",
      promise3Text: "Wir sind von der Qualität unserer Analyse überzeugt. Sollten Sie nicht zufrieden sein, stehen wir zu unserem Wort.",
      promiseOutro: "Centeo ist Ihr unabhängiger und neutraler Partner auf dem Weg zur optimalen Förderung.",
      backButton: "Zurück zur Startseite"
    },
    es: {
      title: "Sobre Nosotros",
      subtitle: "Nuestras raíces, su futuro: La historia detrás de Centeo",
      missionTitle: "Nuestra misión: Claridad en la jungla de subvenciones",
      missionText1: "La financiación agrícola en la UE es un laberinto de solicitudes, regulaciones cambiantes e innumerables programas. Fundamos Centeo porque creemos que cada agricultor, independientemente del tamaño de la explotación o los conocimientos técnicos, merece un acceso justo y sencillo al apoyo que le corresponde.",
      missionText2: "Nuestra misión es romper la complejidad del panorama de financiación a través de tecnología inteligente y fortalecer el futuro de la agricultura europea mostrando a cada explotación las mejores oportunidades financieras posibles.",
      originTitle: "Nuestro origen: Agricultura en el corazón, datos en la mente",
      originText1: "Detrás de Centeo está Lazzaro One UG, pero sobre todo una historia personal. Nuestro fundador, Arsenio Longo, proviene de una familia que ha estado en la agricultura durante generaciones. Conoce por experiencia propia el trabajo duro, la pasión y también los desafíos económicos que conlleva la vida como agricultor.",
      originText2: "Esta profunda conexión con la agricultura la combina con su doble experiencia en matemáticas y finanzas.",
      originText3: "Esta combinación única nos permite no solo entender analíticamente el complejo mundo de los programas de financiación, sino también verlo siempre desde la perspectiva de un agricultor: ¿Qué realmente aporta valor a la explotación y asegura su futuro? Centeo es nuestra respuesta a esta pregunta.",
      methodTitle: "Nuestro método: Más que solo una base de datos",
      methodIntro: "Centeo es más que un simple motor de búsqueda. Nuestro sistema utiliza un proceso de múltiples etapas asistido por IA para encontrar los resultados más relevantes para usted:",
      method1Title: "1. Recopilación integral de datos:",
      method1Text: "Recopilamos y mantenemos continuamente una base de datos con cientos de programas, desde los conocidos pagos PAC hasta fundaciones privadas, beneficios fiscales y financiaciones de nicho que a menudo se pasan por alto (\"Gemas Ocultas\").",
      method2Title: "2. Emparejamiento inteligente y puntuación:",
      method2Text: "Nuestro algoritmo analiza los datos de su explotación y evalúa individualmente cada programa encontrado para ordenar los resultados según la mayor probabilidad de éxito y ajuste para su situación específica.",
      method3Title: "3. Análisis estratégico:",
      method3Text: "Identificamos adicionalmente qué financiaciones se pueden combinar entre sí para ayudarle a maximizar su potencial de financiación y crear \"paquetes de financiación\" estratégicos.",
      promiseTitle: "Nuestra promesa para usted",
      promiseIntro: "Su confianza es nuestro bien más preciado. Por eso nos comprometemos a los siguientes principios:",
      promise1Title: "Protección de datos según GDPR:",
      promise1Text: "Los datos de su explotación se tratan de forma estrictamente confidencial, se utilizan solo para el análisis único y nunca se comparten con terceros sin su consentimiento.",
      promise2Title: "Costos transparentes:",
      promise2Text: "Un precio único para un análisis completo. Sin suscripciones, sin tarifas ocultas.",
      promise3Title: "Garantía de devolución del dinero:",
      promise3Text: "Estamos convencidos de la calidad de nuestro análisis. Si no está satisfecho, cumplimos nuestra palabra.",
      promiseOutro: "Centeo es su socio independiente y neutral en el camino hacia la financiación óptima.",
      backButton: "Volver al inicio"
    },
    it: {
      title: "Chi Siamo",
      subtitle: "Le nostre radici, il vostro futuro: La storia dietro Centeo",
      missionTitle: "La nostra missione: Chiarezza nella giungla dei finanziamenti",
      missionText1: "Il finanziamento agricolo nell'UE è un labirinto di domande, regolamenti in continua evoluzione e innumerevoli programmi. Abbiamo fondato Centeo perché crediamo che ogni agricoltore, indipendentemente dalle dimensioni dell'azienda o dalle competenze tecniche, meriti un accesso equo e semplice al supporto che gli spetta.",
      missionText2: "La nostra missione è rompere la complessità del panorama dei finanziamenti attraverso tecnologie intelligenti e rafforzare il futuro dell'agricoltura europea mostrando a ogni azienda le migliori opportunità finanziarie possibili.",
      originTitle: "La nostra origine: Agricoltura nel cuore, dati nella mente",
      originText1: "Dietro Centeo c'è Lazzaro One UG, ma soprattutto una storia personale. Il nostro fondatore, Arsenio Longo, proviene da una famiglia che è stata nell'agricoltura per generazioni. Conosce per esperienza diretta il duro lavoro, la passione e anche le sfide economiche che comporta la vita da agricoltore.",
      originText2: "Questa profonda connessione con l'agricoltura la combina con la sua doppia competenza in matematica e finanza.",
      originText3: "Questa combinazione unica ci permette non solo di comprendere analiticamente il complesso mondo dei programmi di finanziamento, ma anche di vederlo sempre dalla prospettiva di un agricoltore: Cosa porta realmente valore all'azienda e ne assicura il futuro? Centeo è la nostra risposta a questa domanda.",
      methodTitle: "Il nostro metodo: Più di un semplice database",
      methodIntro: "Centeo è più di un semplice motore di ricerca. Il nostro sistema utilizza un processo multi-fase assistito dall'IA per trovare i risultati più rilevanti per voi:",
      method1Title: "1. Raccolta dati completa:",
      method1Text: "Raccogliamo e manteniamo continuamente un database con centinaia di programmi, dai noti pagamenti PAC alle fondazioni private, agevolazioni fiscali e finanziamenti di nicchia che spesso vengono trascurati (\"Gemme Nascoste\").",
      method2Title: "2. Abbinamento intelligente e punteggio:",
      method2Text: "Il nostro algoritmo analizza i dati della vostra azienda e valuta individualmente ogni programma trovato per ordinare i risultati secondo la più alta probabilità di successo e adattamento alla vostra situazione specifica.",
      method3Title: "3. Analisi strategica:",
      method3Text: "Identifichiamo inoltre quali finanziamenti possono essere combinati tra loro per aiutarvi a massimizzare il vostro potenziale di finanziamento e creare \"pacchetti di finanziamento\" strategici.",
      promiseTitle: "La nostra promessa per voi",
      promiseIntro: "La vostra fiducia è il nostro bene più prezioso. Per questo ci impegniamo ai seguenti principi:",
      promise1Title: "Protezione dati secondo GDPR:",
      promise1Text: "I dati della vostra azienda vengono trattati in modo strettamente confidenziale, utilizzati solo per l'analisi unica e mai condivisi con terzi senza il vostro consenso.",
      promise2Title: "Costi trasparenti:",
      promise2Text: "Un prezzo unico per un'analisi completa. Nessun abbonamento, nessuna tariffa nascosta.",
      promise3Title: "Garanzia di rimborso:",
      promise3Text: "Siamo convinti della qualità della nostra analisi. Se non siete soddisfatti, manteniamo la nostra parola.",
      promiseOutro: "Centeo è il vostro partner indipendente e neutrale nel percorso verso il finanziamento ottimale.",
      backButton: "Torna alla homepage"
    }
  };

  const t = content[lang] || content.de;

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="pt-8">
        <div className="container mx-auto px-6 py-12 max-w-4xl">
          {/* Back Button */}
          <div className="mb-8">
            <button
              onClick={onBack}
              className="inline-flex items-center text-green-600 hover:text-green-700 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              {t.backButton}
            </button>
          </div>

          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">{t.title}</h1>
            <h2 className="text-xl text-green-700 font-medium">{t.subtitle}</h2>
          </div>
          
          {/* Mission Section */}
          <section className="mb-12 bg-white rounded-lg shadow-sm p-8">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">{t.missionTitle}</h3>
            <p className="mb-6 text-gray-700 leading-relaxed text-lg">{t.missionText1}</p>
            <p className="text-gray-700 leading-relaxed text-lg">{t.missionText2}</p>
          </section>

          {/* Origin Section */}
          <section className="mb-12 bg-white rounded-lg shadow-sm p-8">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">{t.originTitle}</h3>
            <p className="mb-6 text-gray-700 leading-relaxed">{t.originText1}</p>
            <p className="mb-6 text-gray-700 leading-relaxed">{t.originText2}</p>
            <p className="text-gray-700 leading-relaxed">{t.originText3}</p>
          </section>

          {/* Method Section */}
          <section className="mb-12 bg-white rounded-lg shadow-sm p-8">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">{t.methodTitle}</h3>
            <p className="mb-8 text-gray-700 leading-relaxed text-lg">{t.methodIntro}</p>
            
            <div className="space-y-6">
              <div className="bg-green-50 border-l-4 border-green-500 p-6 rounded-r-lg">
                <h4 className="font-semibold text-green-800 mb-3 text-lg">{t.method1Title}</h4>
                <p className="text-gray-700 leading-relaxed">{t.method1Text}</p>
              </div>
              
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg">
                <h4 className="font-semibold text-blue-800 mb-3 text-lg">{t.method2Title}</h4>
                <p className="text-gray-700 leading-relaxed">{t.method2Text}</p>
              </div>
              
              <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-r-lg">
                <h4 className="font-semibold text-purple-800 mb-3 text-lg">{t.method3Title}</h4>
                <p className="text-gray-700 leading-relaxed">{t.method3Text}</p>
              </div>
            </div>
          </section>

          {/* Promise Section */}
          <section className="mb-12 bg-white rounded-lg shadow-sm p-8">
            <h3 className="text-2xl font-semibold mb-6 text-gray-900">{t.promiseTitle}</h3>
            <p className="mb-8 text-gray-700 leading-relaxed text-lg">{t.promiseIntro}</p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <span className="font-semibold text-gray-900 text-lg">{t.promise1Title}</span>
                  <p className="text-gray-700 mt-1">{t.promise1Text}</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <span className="font-semibold text-gray-900 text-lg">{t.promise2Title}</span>
                  <p className="text-gray-700 mt-1">{t.promise2Text}</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-3 h-3 bg-green-500 rounded-full mt-2 flex-shrink-0"></div>
                <div>
                  <span className="font-semibold text-gray-900 text-lg">{t.promise3Title}</span>
                  <p className="text-gray-700 mt-1">{t.promise3Text}</p>
                </div>
              </div>
            </div>
            
            <div className="mt-8 p-6 bg-green-50 rounded-lg border border-green-200">
              <p className="text-gray-700 font-medium italic text-lg text-center">{t.promiseOutro}</p>
            </div>
          </section>

          {/* CTA Section */}
          <section className="text-center">
            <button
              onClick={onBack}
              className="bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition-colors text-lg font-medium"
            >
              {t.backButton}
            </button>
          </section>
        </div>
      </main>
    </div>
  );
};

export default AboutUsPage;